import { useState } from 'react';
import { $t } from 'hooks/i18n';
import { Title } from 'components/Title';

export default function NogzonePage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="NogzonePage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title={$t('nogzone')}   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
